import get from 'lodash/get';
import find from 'lodash/find';
import forOwn from 'lodash/forOwn';
import { SEARCH_TYPES, ABST_PROTEIN, PROTEIN_DB, SEARCH_TYPE_BE_TO_FE, } from './index';
import { configOptions, shortAlgorithmConfig, configKeys } from './constantConfig';
import { MODIFICATION_SEARCH_ALGORITHM_TYPES } from './index';
export const preferenceConfig = {
    [SEARCH_TYPES.sequence]: {
        perc_identity: { start: 80, end: 100 },
        q_perc_identity: { start: 0, end: 100 },
        qcov_hsp_perc: { start: 0, end: 100 },
        s_perc_identity: { start: 0, end: 100 },
        subject_length: { start: 0, end: '' },
        scov_hsp_perc: { start: 0, end: 100 },
        evalue: 1e6,
        low_complexity_region: false,
        ungapped: false,
        limit: 5000,
        // algorithmSettings:
    },
    [SEARCH_TYPES.degenerate]: {
        perc_identity: { start: 80, end: 100 },
        q_perc_identity: { start: 0, end: 100 },
        qcov_hsp_perc: { start: 0, end: 100 },
        s_perc_identity: { start: 0, end: 100 },
        subject_length: { start: 0, end: '' },
        scov_hsp_perc: { start: 0, end: 100 },
        evalue: 1e6,
        low_complexity_region: false,
        ungapped: false,
        limit: 5000,
        option: [15, 4],
    },
    [SEARCH_TYPES.combined]: {
        perc_identity: { start: 80, end: 100 },
        q_perc_identity: { start: 0, end: 100 },
        qcov_hsp_perc: { start: 80, end: 100 },
        s_perc_identity: { start: 0, end: 100 },
        subject_length: { start: 0, end: '' },
        scov_hsp_perc: { start: 0, end: 100 },
        evalue: 1e6,
        low_complexity_region: false,
        ungapped: false,
    },
    [SEARCH_TYPES.short]: {
        perc_identity: { start: 60, end: 100 },
        q_perc_identity: { start: 0, end: 100 },
        qcov_hsp_perc: { start: 60, end: 100 },
        s_perc_identity: { start: 0, end: 100 },
        scov_hsp_perc: { start: 0, end: 100 },
        evalue: 1e6,
        low_complexity_region: false,
        ungapped: false,
    },
    [SEARCH_TYPES.cdr]: {
        evalue: 1e6,
        low_complexity_region: false,
        ungapped: false,
    },
    [SEARCH_TYPES.motif]: {
        subject_length: { start: 0, end: '' },
        perc_identity: { start: 80, end: 100 },
        qcov_hsp_perc: { start: 80, end: 100 },
        scov_hsp_perc: { start: 0, end: 100 },
        evalue: 1e6,
        low_complexity_region: false,
        ungapped: false,
        limit: 5000,
    },
    [SEARCH_TYPES.motif2]: {
        subject_length: { start: 0, end: '' },
        scov_hsp_perc: { start: 0, end: 100 },
        limit: 5000,
    },
    [SEARCH_TYPES.fragment]: {
        perc_identity: { start: 95, end: 100 },
        evalue: 1e6,
        low_complexity_region: false,
        ungapped: false,
        subject_length: { start: 0, end: '' },
        limit: 5000,
    },
    [SEARCH_TYPES.antibody]: {
        subject_length: { start: 0, end: '' },
        perc_identity: { start: 80, end: 100 },
        q_perc_identity: { start: 0, end: 100 },
        qcov_hsp_perc: { start: 80, end: 100 },
        s_perc_identity: { start: 0, end: 100 },
        scov_hsp_perc: { start: 0, end: 100 },
        evalue: 1e6,
        low_complexity_region: false,
        ungapped: false,
    },
    [SEARCH_TYPES.modification]: {
        perc_identity: { start: 80, end: 100 },
        q_perc_identity: { start: 0, end: 100 },
        qcov_hsp_perc: { start: 0, end: 100 },
        s_perc_identity: { start: 0, end: 100 },
        // subject_length: { start: 0, end: '' },
        scov_hsp_perc: { start: 0, end: 100 },
        evalue: 1e6,
        low_complexity_region: false,
        ungapped: false,
        limit: 5000,
        algorithm_type: 'Nw',
        gap_extend: 1,
        gap_open: 10,
        score_matrix: 'BLOSUM62',
        option: [15, 4],
    },
};
export function getDefaultSettings(searchType) {
    const feSearchType = SEARCH_TYPE_BE_TO_FE[searchType];
    return preferenceConfig[feSearchType];
}
function configOptionsType(sequenceType, dbType) {
    if (sequenceType === ABST_PROTEIN) {
        if (dbType === PROTEIN_DB) {
            return configKeys.protTypeProtDbConfigs;
        }
        return configKeys.protTypeNucDbConfigs;
    }
    if (dbType === PROTEIN_DB) {
        return configKeys.nucTypeProtDbConfigs;
    }
    return configKeys.nucTypeNucDbConfigs;
}
export function getDefaultAlgorithm(sequenceType, dbType) {
    const configOptionType = configOptionsType(sequenceType, dbType);
    const defaultConfigs = {
        automatic: true,
        algorithm: '',
        matrix: '',
        word_size: 0,
        gaps: '',
        match_scores: '',
    };
    const currentConfigOptions = configOptions[configOptionType];
    if (currentConfigOptions.algorithmOptions.length > 0) {
        const { algorithmOptions } = currentConfigOptions;
        if (currentConfigOptions.automatic) {
            // 每次切换有显示改checkbox的序列种类或者数据库，都将默认勾选
            defaultConfigs.automatic = true;
        }
        const defaultAlgorithm = get(find(algorithmOptions, ['default', true]), 'value');
        defaultConfigs.algorithm = defaultAlgorithm;
        const defaultOptionList = get(find(algorithmOptions, (algorithm) => defaultAlgorithm === algorithm.value), 'children');
        forOwn(defaultOptionList, (value, key) => {
            defaultConfigs[key] = get(find(value, ['default', true]), 'value');
        });
        defaultConfigs.algorithm = defaultAlgorithm;
    }
    return defaultConfigs;
}
export const shortDefaultAlgorithms = [
    'blastn-short',
    'blastp-short',
    'blastx-fast',
    'tblastn-fast',
];
export function getShortDefaultAlgorithm(sequenceType, dbType) {
    const configOptionType = configOptionsType(sequenceType, dbType);
    const defaultConfigs = {
        automatic: true,
        word_size: 0,
        algorithm: '',
        matrix: '',
        gaps: '',
        match_scores: '',
    };
    const currentConfigOptions = configOptions[configOptionType];
    if (currentConfigOptions.algorithmOptions.length > 0) {
        const { algorithmOptions } = currentConfigOptions;
        if (currentConfigOptions.automatic) {
            // 每次切换有显示改checkbox的序列种类或者数据库，都将默认勾选
            defaultConfigs.automatic = true;
        }
        const defaultAlgorithm = get(find(algorithmOptions, (option) => shortDefaultAlgorithms.includes(option.value)), 'value');
        defaultConfigs.algorithm = defaultAlgorithm;
        const defaultOptionList = get(find(algorithmOptions, (algorithm) => defaultAlgorithm === algorithm.value), 'children');
        forOwn(defaultOptionList, (value, key) => {
            if (key === 'word_size') {
                const currentConfigOptions = shortAlgorithmConfig[configOptionType];
                if (currentConfigOptions) {
                    defaultConfigs.word_size = get(find(currentConfigOptions.word_size, ['default', true]), 'value');
                }
            }
            else {
                defaultConfigs[key] = get(find(value, ['default', true]), 'value');
            }
        });
        defaultConfigs.algorithm = defaultAlgorithm;
    }
    return defaultConfigs;
}
export const AlgorithmSettingFields = {
    [MODIFICATION_SEARCH_ALGORITHM_TYPES.Blast]: [
        'algorithm',
        'automatic',
        'gaps',
        'match_scores',
        'matrix',
        'word_size',
    ],
    [MODIFICATION_SEARCH_ALGORITHM_TYPES.NW]: []
};
